import React from 'react';

interface ComponentProps {
  /** Esc: back to the list, to the active row (the pane stays open). */
  onEscape: () => void;
  children: React.ReactNode;
}

/**
 * The detail side of the split view: the row's detail, with no bar above it — rows are switched in the
 * list (click, ↑/↓). There is no close button — the layout is the user's choice, switched in the
 * profile menu.
 */
const DetailPane: React.FC<ComponentProps> = ({ onEscape, children }) => (
  <div
    className="flex min-h-full flex-col"
    onKeyDown={event => {
      if (event.key === 'Escape') {
        event.stopPropagation();
        onEscape();
      }
    }}
    data-testid="split-detail-pane"
  >
    <div className="flex-1 pl-2 pr-4 pb-4">{children}</div>
  </div>
);

export default DetailPane;
